
import { useContext, useEffect, useMemo, useState } from 'react';

import './App.scss';

import {
  createBrowserRouter,
  Navigate,
  redirect,
  RouterProvider
} from "react-router-dom";

import { UseAuthentification } from './common/hooks';
import { UserService } from './common/services';
import { AuthContext, AppContext, LOCAL_STORAGE_KEYS, USER_ROLE } from './common/constants';

import { Profil, MainLayout, Login, Operations, ChiffreAffaire, Commissions, Rechargements, Terminal, TerminalDetails, Consultation, Clients, Operateurs } from './pages';
import Operation from './pages/consultation/operation.component';
import { DateHelper } from './common/helper';
import ReportingConcessionnaires from './pages/reportings/reporting-concessionnaires.component';
import ReportingTerminaux from './pages/reportings/reporting-terminaux.component';
import ReportingRechargements from './pages/reportings/reporting-rechargements.component';
import ReportingChiffreAffaire from './pages/reportings/reporting-chiffre-affaire-concessionnaire';
import ReportingTerminauxCanaux from './pages/reportings/reporting-terminaux-canaux.component';

// Les comptes CONSULTATION n'ont accès qu'aux reportings
function Home() {
  const auth = useContext(AuthContext);
  return auth?.currentUser?.role === USER_ROLE.CONSULTATION ? <Navigate to="/reportings" replace /> : <Clients />;
}

function App() {

  const [appStore, setAppState] = useState({ month: DateHelper.getMonthAndYear() });

  const auth = UseAuthentification();

  const dispatcher = (newState) => setAppState(_state => ({ ..._state, ...newState }))



  const [timeout, setTimeoutId] = useState(null);

  // useEffect(() => {
  //   const logout = () => {
  //     // Mettre ici le code de déconnexion de l'utilisateur
  //     auth.onLogout();
  //   };

  //   const timer = setTimeout(logout, 5 * 60 * 1000);

  //   setTimeoutId(timer);

  //   // Nettoyer le délai d'attente lors du démontage du composant ou lorsque le délai doit être réinitialisé
  //   return () => {
  //     clearTimeout(timeout);
  //   };
  // }, []);

  // Sans jeton ou sans utilisateur valide, on renvoie vers la page de connexion
  const authLoader = async () => {
    if (!localStorage.getItem(LOCAL_STORAGE_KEYS.ACCESS_TOKEN)) return redirect("/login");
    try {
      const user = await UserService.getUserInfo();
      if (!user || user.status) throw new Error("Utilisateur invalide");
      return user;
    } catch (error) {
      auth.onLogout();
    }
    return null;
  }

  const routers = useMemo(() => createBrowserRouter([
    {
      path: "/dashboard/:id",
      element: <MainLayout />,
      errorElement: <div>Not found</div>,
      children: [
        {
          path: "",
          element: <Terminal />,
        },
        {
          path: "terminal/:id",
          element: <TerminalDetails />,
        },
        {
          path: "operations",
          element: <Operations />,
        },
        {
          path: "chiffres-affaires",
          element: <ChiffreAffaire />,
        },
        {
          path: "commissions",
          element: <Commissions />,
        },
        {
          path: "rechargements",
          element: <Rechargements />,
        },
        {
          path: "consultations",
          element: <Consultation />,
        },
        {
          path: "consultations-operation",
          element: <Operation />,
        }

      ],
      loader: authLoader
    },
    {
      path: "/",
      element: <Home />,
      errorElement: <div>Not found</div>,
      loader: authLoader
    },
    {
      path: "/operateurs",
      element: <Operateurs />,
      errorElement: <div>Not found</div>,
      loader: authLoader
    },
    // REPORTING
    {
      path: "/reportings",
      element: <Navigate to="/reportings/concessionnaires" replace />,
    },
    {
      path: "/reportings/concessionnaires",
      loader: authLoader,
      errorElement: <div>Not found</div>,
      element: <ReportingConcessionnaires />,
    },
    {
      path: "/reportings/terminaux",
      loader: authLoader,
      errorElement: <div>Not found</div>,
      element: <ReportingTerminaux />,
    },
    {
      path: "/reportings/rechargements",
      loader: authLoader,
      errorElement: <div>Not found</div>,
      element: <ReportingRechargements />,
    },
    {
      path: "/reportings/chiffre-affaires",
      loader: authLoader,
      errorElement: <div>Not found</div>,
      element: <ReportingChiffreAffaire />,
    },
    {
      path: "/reportings/terminaux/rechargement-canaux",
      loader: authLoader,
      errorElement: <div>Not found</div>,
      element: <ReportingTerminauxCanaux />,
    },
    {
      path: "/profil",
      loader: authLoader,
      element: <Profil />,
      errorElement: <div>Not found</div>
    },
    {
      path: "/login",
      element: <Login />,
      errorElement: <Login />//<div>Not found</div>,
    },
    {
      // Chemin inconnu : "/" renvoie vers /login si l'utilisateur n'est pas connecté
      path: "*",
      element: <Navigate to="/" replace />,
    }
  ]), []);

  return (
    <div className="App">
      <AuthContext.Provider value={auth}>
        <AppContext.Provider value={{ store: appStore, dispatcher }}>
          <RouterProvider router={routers} />
        </AppContext.Provider>
      </AuthContext.Provider>
    </div>
  );
}

export default App;
